import { Box } from '@mui/material'
import { shipmentNestedTabs } from '../utils/consts'
import NestedTabsPage from '../layouts/NestedTabsPage'
import { Entity } from 'utils/hooks/usePermissions'
import { Navigate } from 'react-router-dom'
import { NoPermission } from 'pages/NoPermission/NoPermission'
import { useDataPermissions } from '../hooks/useDataPermissions'

const ShipmentsData = () => {
  // Check permissions using the custom hook
  const { hasPermission, redirectPath, showNoPermission } = useDataPermissions(
    Entity.WHEAT_CODE,
    'SHOW_WHEAT'
  )

  // Handle redirection or no permission
  if (!hasPermission) {
    if (redirectPath) {
      return <Navigate to={redirectPath} replace />
    }
    if (showNoPermission) {
      return <NoPermission />
    }
  }

  return (
    <Box>
      <Box>
        <NestedTabsPage tabsList={shipmentNestedTabs} />
      </Box>
    </Box>
  )
}

export default ShipmentsData
